import React from 'react'
import TotalProducts from './TotalProducts'
import ProductSidebar from './ProductSidebar'

export default function ProductFeatures() {
    return (
        <div className="feature-products">
            <TotalProducts />
            <ProductSidebar/>
        </div>
    )
}